import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/LoginPage';
import OwnersPage from './pages/OwnersPage';
import ExileGuardDashboardLayout from './components/layout/ExileGuardDashboardLayout';
import ThemeProvider from './styles/ThemeProvider';
import HomePage from './pages/HomePage';
import CharacterManagementPage from './pages/CharacterManagementPage';
import Notification from './components/Notification';
import ItemInventoryPage from './pages/ItemInventoryPage';
import AlertsPage from './pages/AlertsPage';
import MarketAnalysisPage from './pages/MarketAnalysisPage';
import TasksPage from './pages/TasksPage';
import ExileGuardPage from './pages/ExileGuardPage';
import TimetablesPage from './pages/TimetablesPage';
import CleanupPage from './pages/CleanupPage';
import AlertSopMappingsPage from './pages/AlertSopMappingsPage';
import RMTPage from './pages/RMTPage';
import FlipsPage from './pages/FlipsPage';
import { ProtectedComponent } from './components/protected/AuthenticatedComponent';
import { AdminComponent } from './components/protected/AdminComponent';
import { FeatureComponent } from './components/protected/FeatureComponent';
import GlobalAlertsManager from './components/GlobalAlertsManager';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        {/* Global notification component for displaying errors like 401 Unauthorized */}
        <Notification />
        {/* Global alerts manager for auto-refresh and sound notifications */}
        <GlobalAlertsManager />
        <Routes>
          <Route path='/login' element={<LoginPage />} />
          <Route
            path='/*' // Using /* to match all routes under the dashboard
            element={
              <ProtectedComponent>
                <ExileGuardDashboardLayout />
              </ProtectedComponent>
            }
          >
            {/* Nested routes will be rendered inside ExileGuardDashboardLayout's Outlet */}
            <Route index element={<HomePage />} /> {/* Default for / */}
            <Route path='characters' element={<CharacterManagementPage />} />
            <Route path='items' element={<ItemInventoryPage />} />
            <Route path='alerts' element={<AlertsPage />} />
            <Route path='market' element={<MarketAnalysisPage />} />
            <Route
              path='owners'
              element={
                <AdminComponent>
                  <OwnersPage />
                </AdminComponent>
              }
            />
            <Route
              path='tasks'
              element={
                <AdminComponent>
                  <TasksPage />
                </AdminComponent>
              }
            />
            <Route
              path='cleanup'
              element={
                <AdminComponent>
                  <CleanupPage />
                </AdminComponent>
              }
            />
            <Route
              path='exileguard'
              element={
                <FeatureComponent feature='ExileGuard'>
                  <ExileGuardPage />
                </FeatureComponent>
              }
            />
            <Route
              path='timetables'
              element={
                <FeatureComponent feature='Timetables'>
                  <TimetablesPage />
                </FeatureComponent>
              }
            />
            <Route
              path='alert-sop-mappings'
              element={
                <FeatureComponent feature='AlertSopLinks'>
                  <AlertSopMappingsPage />
                </FeatureComponent>
              }
            />
            <Route
              path='rmt'
              element={
                <FeatureComponent feature='RMT'>
                  <RMTPage />
                </FeatureComponent>
              }
            />
            <Route
              path='flips'
              element={
                <FeatureComponent feature='Flips'>
                  <FlipsPage />
                </FeatureComponent>
              }
            />
            {/* Catch-all for dashboard, redirect to home or show a 404 within layout */}
            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
